import React, { useEffect, useState } from 'react'
import moment from 'moment-timezone'
import { ApiRequest } from '../../services/api/api'

let cachedEmployeeMap: Record<number, string> = {}
let employeeFetchPromise: Promise<void> | null = null

const loadEmployees = (): Promise<void> => {
  if (Object.keys(cachedEmployeeMap).length) return Promise.resolve()
  if (!employeeFetchPromise) {
    employeeFetchPromise = ApiRequest({ url: 'Employee/GetAllEmployee', method: 'get' }).then((res: any) => {
      const map: Record<number, string> = {}
      ;(res?.data?.data || []).forEach((e: any) => {
        map[e.employeeId] = `${e.firstName} ${e.lastName}`
      })
      cachedEmployeeMap = map
    })
  }
  return employeeFetchPromise!
}

const EmployeeName = ({ id }: { id: number | null | undefined }) => {
  const [name, setName] = useState<string>(() => (id ? cachedEmployeeMap[id] || '' : ''))

  useEffect(() => {
    if (!id) return
    if (cachedEmployeeMap[id]) {
      setName(cachedEmployeeMap[id])
      return
    }
    loadEmployees().then(() => setName(cachedEmployeeMap[id] || ''))
  }, [id])

  return <>{name}</>
}

const ExceptionalLogColumnModel = (): any => {
  return [
    {
      title: 'Data',
      field: 'createAt',
      editable: 'never',
      render: (rowData: any) => rowData.createAt ? moment.utc(rowData.createAt).tz('Pacific/Auckland').format('YYYY-MM-DD HH:mm') : '',
    },
    {
      title: 'Error Page',
      field: 'page',
      editable: 'never',
    },
    {
      title: 'Error Reason',
      field: 'triggerReason',
      editable: 'never',
    },
    {
      title: 'Operate Reason',
      field: 'reason',
      editable: 'never',
    },
    {
      title: 'Operator',
      field: 'createBy',
      editable: 'never',
      render: (rowData: any) => <EmployeeName id={rowData.createBy} />,
    },
  ]
}

export default ExceptionalLogColumnModel
